export const PAYMENTS_QUERY_SEARCH_PARAM_KEY = 'paymentQuery';
